export enum SubscriberType {
	None = 'None',
	Account = 'Account',
	SystemEntity = 'SystemEntity',
	AccountOrSystemEntity = 'AccountOrSystemEntity',
}
